import { Column, Index, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import type { TradeShowChecklistAssignee, TradeShowChecklistPlan } from '../../constants/trade-shows';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/** A named checklist in Settings → Trade shows, applied when a show's plan is set (PD-17632). */
@Entity('trade_show_checklist')
export class TradeShowChecklistEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 120 })
	public name!: string;

	@Column('varchar', { name: 'plan', length: 20 })
	public plan!: TradeShowChecklistPlan;

	@OneToMany(() => TradeShowChecklistItemEntity, (item) => item.checklist)
	public items?: Array<TradeShowChecklistItemEntity>;
}

@Entity('trade_show_checklist_item')
@Index('idx_trade_show_checklist_item_list', ['checklistId'])
export class TradeShowChecklistItemEntity extends BaseEntity {
	@Column('int', { name: 'fk_trade_show_checklist__id' })
	public checklistId!: number;

	@ManyToOne(() => TradeShowChecklistEntity, (checklist) => checklist.items, { createForeignKeyConstraints: false })
	@JoinColumn({ name: 'fk_trade_show_checklist__id' })
	public checklist?: TradeShowChecklistEntity;

	/** Days from the show: negative counts back from its start, positive on from its end. */
	@Column('int', { name: 'daysFromShow' })
	public daysFromShow!: number;

	@Column('varchar', { name: 'title', length: 255 })
	public title!: string;

	@Column('varchar', { name: 'assignTo', length: 20, default: 'owner' })
	public assignTo!: TradeShowChecklistAssignee;

	@Column('int', { name: 'sortOrder', default: 0 })
	public sortOrder!: number;
}
